import { Achievement, UserAchievement } from '@vae/server/dist/client'
import dayjs from 'dayjs'

export interface ChartPoint {
	date: number
	points: number
}

export const generateChartData = (
	achievements: (UserAchievement & { achievement: Achievement })[]
): ChartPoint[] => {
	const filteredAchievements = achievements.filter(({ completedAt }) => {
		return completedAt && dayjs(completedAt).isSame(dayjs(), 'month')
	})

	const dailyPoints: Record<number, { date: number; points: number }> = {}

	for (const { completedAt, achievement } of filteredAchievements) {
		const day = dayjs(completedAt!).date()
		if (dailyPoints[day]) {
			dailyPoints[day].points += achievement.points
		} else {
			dailyPoints[day] = { date: day, points: achievement.points }
		}
	}

	const sortedDays = Object.keys(dailyPoints)
		.map(Number)
		.sort((a, b) => a - b)

	if (!dailyPoints[1]) {
		dailyPoints[1] = { date: 1, points: 0 }
		sortedDays.unshift(1)
		sortedDays.sort((a, b) => a - b)
	}

	let cumulativePoints = 0
	return sortedDays.map(day => {
		cumulativePoints += dailyPoints[day].points
		return {
			date: day,
			points: cumulativePoints,
		}
	})
}
